
@if ((!sceneFeaturesList || sceneFeaturesList.length === 0) ) {
  <div style="margin-top: 24px; margin-right: 10px;" >
    <div style="margin-left: 20px">
      <div class="no-data" style="margin-right: 10px;">
        <div class="no-equipment">
          {{"lang.no_features" | translate}}
        </div>
      </div>
    </div>
  </div>
}

<div class="mt-4 col-12">
  @for (feature of sceneFeaturesList || []; track feature) {
    <div class="border-style-equipment mb-4">
      <div>
        <div class="site-container ms-n1">
          <div class="mt-2 ms-2 equipment-name">
            <!-- Show water feature icon if waterFeature and iconId exists -->
            @if (feature.category === 'waterFeature' && feature.iconId) {
              <img width="26px"
                [src]="getWaterFeatureIconSrc(feature.iconId)">
            }
            <!-- Otherwise show mapped icon -->
            @if (feature.category !== 'waterFeature' && getFeatureIcon(feature.category)) {
              <img width="26px"
                [src]="getFeatureIcon(feature.category)">
            }
            <a (click)="this.setLocalStorage(feature)" [routerLink]="getFeatureRouterLink(feature)"> {{feature?.featureName || '-' }} </a>
          </div>
        </div>
        <hr class="mx-2 my-0">
        <div class="grid-container p-2">
          <!-- Current Status -->
          <div class="m-2" [ngClass]="feature?.activityType?.toLowerCase() === 'lightgroup' ? 'grid-item-25' : 'grid-item'">
            <span class="equipment-grid">{{ 'lang.current_status' | translate }}</span><br>
            <span class="equipment-grid-value">
              @if (feature?.status?.state !== 'On') {
                {{ feature?.status?.state }}
              }
              @if (feature?.status?.state === 'On') {
                @if (feature?.status?.detail) {
                  {{'lang.on' | translate}} | {{ feature?.status?.detail }}
                } @else {
                  {{'lang.on' | translate}}
                }
              }
              @if (!feature?.status?.state) {
                -
              }
            </span>
          </div>
          <!-- Smart Lighting feature states -->
           @if(feature?.activityType?.toLowerCase() === 'lightgroup'){
            <div class="m-2" [ngClass]="feature?.activityType?.toLowerCase() === 'lightgroup' ? 'grid-item-25' : 'grid-item'">
                <span class="equipment-grid">{{ 'lang.smart_lighting_mode' | translate }}</span><br>
                <span class="equipment-grid-value">{{ feature?.smartLightingMode || '-' | titlecase}}</span>
            </div>
           }
         
          <!-- Space Details -->
          <div class="m-2" [ngClass]="feature?.activityType?.toLowerCase() === 'lightgroup' ? 'grid-item-25' : 'grid-item'">
            <span class="equipment-grid">{{ 'lang.space' | translate }}</span><br>
            <span class="equipment-grid-value">{{ feature?.space || '-' }}</span>
          </div>
          <!-- Controller -->
          <div class="m-2" [ngClass]="feature?.activityType?.toLowerCase() === 'lightgroup' ? 'grid-item-25' : 'grid-item'">
            <span class="equipment-grid">{{ 'lang.controller' | translate }}</span><br>
            <a class="equipment-grid-value cloud-id"[routerLink]="getControllerProfileRouterLink(feature)">{{ feature?.controllerId || '-' }}</a>
          </div>
        </div>
      </div>
    </div>
  }
</div>